import type { ServiceTypeEnum } from '@bambi/api-client/schemas';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export const serviceTypeOptions: SelectOption[] = [
  {
    label: 'Curb to Curb',
    value: 'curb-to-curb',
  },
  {
    label: 'Door to Door',
    value: 'door-to-door',
  },
  {
    label: 'Door Through Door',
    value: 'door-through-door',
  },
  {
    label: 'Person To Person',
    value: 'person-to-person',
  },
];

export const serviceTypeOptionsMap: Record<ServiceTypeEnum, string> =
  serviceTypeOptions.reduce(
    (acc, option) => {
      return {
        ...acc,
        [option.value]: option.label,
      };
    },
    {} as Record<ServiceTypeEnum, string>
  );
